'use strict';

/* CQ Article Service */

angular.module('storyApp').factory('parselyService', function() {

    var parselyService = {
    	
    	doc: document,
    		
    	passingUrl: function(url) {
    		
    		var  newUrlWithDomain = location.protocol + "//"+this.doc.domain + url;

    		if (typeof PARSELY !== "undefined" && typeof PARSELY.beacon === "object" && typeof PARSELY.beacon.trackPageView === 'function') {
    			
    			PARSELY.beacon.trackPageView({
    		        url: newUrlWithDomain,           // URL to be tracked
    		        urlref: location.href,
    		        js: 1               // flag indicating that this is a dynamic event, keep it "1"
    		    }); 
    		    
    		}
    	}	
   
    }
    
    return parselyService;

});


// WEBPACK FOOTER //
// ./assets/components/threethings/factories/parselyService.js